import { useCallback, useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

export default function AdminAssignments() {
  const [items, setItems] = useState([]);

  const load = useCallback(async () => {
    const r = await api.get("/admin/assignments");
    setItems(r.data);
  }, []);
  useEffect(() => { load(); }, [load]);

  async function review(id, status) {
    try {
      await api.post(`/admin/assignments/${id}/review`, { status, feedback: "Reviewed" });
      toast.success(`Marked ${status}`); load();
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail) || e.message); }
  }

  return (
    <div className="space-y-3" data-testid="admin-assignments">
      {items.map((a) => (
        <div key={a.id} className="rounded-2xl bg-card border border-border p-5">
          <div className="flex items-start justify-between gap-4 flex-wrap">
            <div className="flex-1 min-w-[240px]">
              <p className="font-semibold text-sm">{a.user_name}</p>
              <p className="text-xs text-muted-foreground">{new Date(a.submitted_at).toLocaleString()}</p>
              <p className="mt-2 text-sm">{a.notes}</p>
              {a.drive_link && <a href={a.drive_link} target="_blank" rel="noreferrer" className="text-xs text-primary hover:underline break-all">{a.drive_link}</a>}
            </div>
            <div className="flex items-center gap-2">
              <span className={`text-xs px-2 py-1 rounded-full ${a.status === "approved" ? "bg-emerald-500/15 text-emerald-600" : a.status === "needs_revision" ? "bg-amber-500/15 text-amber-700" : "bg-secondary"}`}>{a.status}</span>
              <Button size="sm" variant="outline" onClick={() => review(a.id, "approved")} data-testid={`approve-${a.id}`}>Approve</Button>
              <Button size="sm" variant="outline" onClick={() => review(a.id, "needs_revision")} data-testid={`revise-${a.id}`}>Revise</Button>
            </div>
          </div>
        </div>
      ))}
      {items.length === 0 && <div className="rounded-2xl bg-card border border-border p-8 text-center text-sm text-muted-foreground">No submissions yet.</div>}
    </div>
  );
}
